import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
export function LoadError({ retry }: { retry: () => unknown }) {
  const { t } = useTranslation();
  return (
    <div role="alert" className="rounded-card border border-line bg-surface p-4">
      <p className="text-sm text-ink-2">{t('errors.loadFailed')}</p>
      <Button onClick={() => void retry()}>{t('common.retry')}</Button>
    </div>
  );
}
